import axios from "../../../util/axios";
export default {
    /**查询  */
    queryList:(data) => axios.get({url:"/alpine/sale/quoted/queryList",data:data}),
    /**删除  */
    delete:(id) => axios.del({url:"/alpine/sale/quoted/delete",data: {id}}),
    /**保存  */
    save:(data) => axios.post({url:"/alpine/sale/quoted/save",data: data}),
}